import {
  getRadioTracks,
  createRadioTrack,
  reorderRadioTracks,
  updateRadioTrack,
  toggleRadioTrack,
  deleteRadioTrack,
} from "./asyncThunks";

export const getRadioTracksBuilder = (builder) => {
  builder.addCase(getRadioTracks.pending, (state) => {
    state.tracks.loading = true;
    state.tracks.error = null;
  });
  builder.addCase(getRadioTracks.fulfilled, (state, { payload }) => {
    state.tracks.data = payload.data;
    state.tracks.loading = false;
  });
  builder.addCase(getRadioTracks.rejected, (state, action) => {
    state.tracks.loading = false;
    state.tracks.error = action.error.message;
  });
};

export const createRadioTrackBuilder = (builder) => {
  builder.addCase(createRadioTrack.pending, (state) => {
    state.tracks.createLoading = true;
  });
  builder.addCase(createRadioTrack.fulfilled, (state, { payload }) => {
    state.tracks.data.push(payload.data);
    state.tracks.createLoading = false;
  });
  builder.addCase(createRadioTrack.rejected, (state) => {
    state.tracks.createLoading = false;
  });
};

export const reorderRadioTracksBuilder = (builder) => {
  // Optimistički: odmah presloži lokalno po ids redosledu (meta.arg)
  builder.addCase(reorderRadioTracks.pending, (state, action) => {
    const byId = new Map(state.tracks.data.map((t) => [t.id, t]));
    const reordered = action.meta.arg
      .map((id) => byId.get(id))
      .filter(Boolean);
    if (reordered.length === state.tracks.data.length) {
      state.tracks.data = reordered;
    }
  });
  builder.addCase(reorderRadioTracks.fulfilled, (state, { payload }) => {
    state.tracks.data = payload.data;
  });
};

export const updateRadioTrackBuilder = (builder) => {
  builder.addCase(updateRadioTrack.fulfilled, (state, { payload }) => {
    const index = state.tracks.data.findIndex((t) => t.id === payload.data.id);
    if (index !== -1) state.tracks.data[index] = payload.data;
  });
};

export const toggleRadioTrackBuilder = (builder) => {
  builder.addCase(toggleRadioTrack.pending, (state) => {
    state.tracks.toggleLoading = true;
  });
  builder.addCase(toggleRadioTrack.fulfilled, (state, { payload }) => {
    const index = state.tracks.data.findIndex((t) => t.id === payload.data.id);
    if (index !== -1) state.tracks.data[index] = payload.data;
    state.tracks.toggleLoading = false;
  });
  builder.addCase(toggleRadioTrack.rejected, (state) => {
    state.tracks.toggleLoading = false;
  });
};

export const deleteRadioTrackBuilder = (builder) => {
  builder.addCase(deleteRadioTrack.pending, (state) => {
    state.tracks.deleteLoading = true;
  });
  builder.addCase(deleteRadioTrack.fulfilled, (state, { payload }) => {
    state.tracks.data = state.tracks.data.filter(
      (t) => t.id !== payload.data.id,
    );
    state.tracks.deleteLoading = false;
  });
  builder.addCase(deleteRadioTrack.rejected, (state) => {
    state.tracks.deleteLoading = false;
  });
};
